module.exports = __webpack_public_path__ + "1bf2b20.woff2";